import React from 'react';
import {useLocation} from 'react-router-dom';

import SearchNav from '../components/Search/SearchNav';
import {useHref, useNavigate} from '../util/react-router-v6-shim';
import {AppTree} from './AppTree';
import {
  CLI_LOGIN_CANCELED_PATH,
  CLI_LOGIN_PATH,
  CLI_LOGIN_SUCCESS_PATH,
} from './auth/authPaths';

const PATHS_WITHOUT_HEADER = new Set([
  CLI_LOGIN_CANCELED_PATH,
  CLI_LOGIN_PATH,
  CLI_LOGIN_SUCCESS_PATH,
]);

const GlobalHeader = () => {
  const {pathname} = useLocation();
  return PATHS_WITHOUT_HEADER.has(pathname) ? null : <SearchNav />;
};

const GLOBAL_HEADER = <GlobalHeader />;

export const AppWithRoutes = () => {
  const navigate = useNavigate();

  return (
    <AppTree navigate={navigate} useHref={useHref} header={GLOBAL_HEADER} />
  );
};
